module.exports = __webpack_public_path__ + "static/media/2.5f3d8a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ourStaff/2.jpg
// module id = 1416
// module chunks = 0